import { Menu, type MenuSelectGroupProps, Text } from "@overmap-ai/blocks"
import type { Project } from "@overmap-ai/common"
import { memo } from "react"

import { SelectItemTemplate } from "../MenuGroups/constants"

export type ProjectSelectGroupProps = MenuSelectGroupProps<Project> & {
	projects: Project[]
}

export const ProjectSelectGroup = memo<ProjectSelectGroupProps>((props) => {
	const { ref, projects, ...rest } = props

	return (
		<Menu.SelectGroup<Project> ref={ref} {...rest}>
			{projects.map((project) => (
				<SelectItemTemplate<Project> key={project.uuid} value={project}>
					<Text className="truncate">{project.name}</Text>
				</SelectItemTemplate>
			))}
		</Menu.SelectGroup>
	)
})
ProjectSelectGroup.displayName = "ProjectSelectGroup"
